var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "155.29169mm",
    height: "148.76689mm",
    viewBox: "0 0 155.29169 148.76689",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 108.65093,
    height: 66.56691,
    id: "rect34245"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 227.03868,
    height: 65.56691,
    id: "rect36121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 221.38182,
    height: 67.688232,
    id: "rect36133"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 94.809708,
    height: 62.03138,
    id: "rect36145"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.927299,
    y: 276.65552,
    width: 221.38182,
    height: 67.688232,
    id: "rect37271"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer8",
    transform: "translate(-404.77168,-191.05119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer10",
    transform: "translate(401.86126,183.1137)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    id: "rect34443",
    width: 150,
    height: 21.766876,
    x: -420.31387,
    y: -9.1416979,
    transform: "translate(425.87013,19.725031)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    id: "rect36075",
    width: 150,
    height: 10.522084,
    x: 5.5562568,
    y: 41.143787
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    id: "rect36077",
    width: 150,
    height: 32.879375,
    x: 5.5562568,
    y: 60.325001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    id: "rect36079",
    width: 150,
    height: 10.522084,
    x: 5.5562568,
    y: 101.93073
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    id: "rect36103",
    width: 150,
    height: 32.879375,
    x: 5.5562568,
    y: 121.17917
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,52.744869,-59.663172)",
    id: "text34243",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect34245)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#3f4444",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan56008"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan56006"
  }, "SO"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,42.685194,-4.2412313)",
    id: "text36119",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect36121)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#3f4444",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan56012"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan56010"
  }, "Code"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,39.495039,26.054942)",
    id: "text36131",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect36133)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#3f4444",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan56016"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan56014"
  }, "MTGA"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,54.167692,52.341021)",
    id: "text36143",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect36145)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#3f4444",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan56020"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan56018"
  }, "..."))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,39.495039,-34.732004)",
    id: "text37269",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect37271)",
      shapePadding: 0.707103,
      display: "inline",
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#3f4444",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60.634766,
    y: 326.02087,
    id: "tspan56024"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "none"
    },
    id: "tspan56022"
  }, "MTGA"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/Plan.b8ca2d723038bdd65cf81aacd8b84e8f.svg";
export { ForwardRef as ReactComponent };